// Tiny cross-component signal for "the unread count just changed."
//
// The bell (Header on mobile, ProviderShell on desktop) polls
// /api/notifications/unread-count on a 60s timer — fine for messages
// ARRIVING, useless for messages being READ, because the inbox lives in
// a different part of the tree and the bell has no idea it happened.
// The visible symptom: open a notification, come back, and the badge is
// still lit for up to a minute.
//
// Rather than lift count state into a context (the bell is mounted in
// two independent shells), the inbox announces changes and every
// mounted bell re-fetches immediately.
export const NOTIFICATIONS_CHANGED = 'avayble:notifications-changed';

export function emitNotificationsChanged() {
  try {
    window.dispatchEvent(new CustomEvent(NOTIFICATIONS_CHANGED));
  } catch (_) {
    // Non-fatal: the bell's poll timer is the backstop.
  }
}
